import React, { Component } from 'react';
import './engage-data-control.css';
import { db } from '../../config/firebase';
import {
  setNewFavorites,
  setNewRetweets,
  setLikesRetweetsDates,

  setNewFollowers,
  setNewFriends,
  setNewTweets,
  setTotalFollowers,
  setTotalFriends,
  setTotalTweets,
  setFollowersFriendsTweetsDates,

  setRepliesMentionsSums,
  setRepliesMentionsDates
}
  from '../../actions/engage-actions';
import moment from 'moment-timezone';
import { connect } from 'react-redux';
import RetweetChart from './charts/RetweetChart';
import FavoriteChart from './charts/FavoriteChart';
import FollowersChart from './charts/FollowersChart';
import FriendsChart from './charts/FriendsChart';
import TweetsChart from './charts/TweetsChart';
import RepliesMentionsChart from './charts/RepliesMentionsChart';
import { List } from 'immutable';


let mapStateToProps = (state) => {
  return {
    new_favorites: state.engage.new_favorites,
    new_retweets: state.engage.new_retweets,
    likes_retweets_dates: state.engage.likes_retweets_dates,
    new_followers: state.engage.new_followers,
    new_friends: state.engage.new_friends,
    new_tweets: state.engage.new_tweets,
    total_followers: state.engage.total_followers,
    total_friends: state.engage.total_friends,
    total_tweets: state.engage.total_tweets,
    followers_friends_tweets_dates: state.engage.followers_friends_tweets_dates,
    replies_mentions_sums: state.engage.replies_mentions_sums,
    replies_mentions_dates: state.engage.replies_mentions_dates,
  };
};

let mapDispatchToProps = (dispatch) => {
  return {
    dispatch
  };
};


class EngageDataControl extends Component {
  constructor(props) {
    super(props);

    this.days = 2;
    this.hours = 24;
  }

  componentDidMount = () => {
    return [
      this.fetchLikesRetweetsData(),
      this.fetchFollowersFriendsTweetsData(),
      this.fetchRepliesMentionsData()
    ];
  };

  fetchRepliesMentionsData = async () => {
    let dispatch = this.props.dispatch;
    let ref1 = db.ref(`engage/girlposts/replies_mentions/record`)
      .limitToLast(this.days);


    await ref1.once('value').then((data) => {
      let replies_mentions_dates = [];
      let replies_mentions_sums = [];

      data.forEach((day_data) => {
        day_data.forEach((hour_data) => {
          let replies_mentions_count = hour_data.val().replies_mentions_total;
          let raw_twt_unix_seconds = hour_data.val().raw_twt_unix_seconds;
          let record_date_time = moment.unix(raw_twt_unix_seconds)
            .tz("America/New_York")
            .format('ddd D MMM hA');

          replies_mentions_dates.push(record_date_time);
          replies_mentions_sums.push(replies_mentions_count);
        });
      });

      let i_replies_mentions_dates
        = List(replies_mentions_dates.slice(-this.hours));
      let i_replies_mentions_sums
        = List(replies_mentions_sums.slice(-this.hours));

      dispatch(setRepliesMentionsSums(i_replies_mentions_sums));
      dispatch(setRepliesMentionsDates(i_replies_mentions_dates));
    });
  };

  fetchFollowersFriendsTweetsData = async () => {
    let dispatch = this.props.dispatch;
    let ref1 = db.ref(`engage/girlposts/followers_friends_tweets/archive`)
      .limitToLast(this.days);

    await ref1.once('value').then((data) => {

      let new_followers = [];
      let new_friends = [];
      let new_tweet = [];
      let total_followers = [];
      let total_friends = [];
      let total_tweets = [];
      let dates = [];

      data.forEach((DATA) => {
        DATA.forEach((RAW_DATA) => {
          let val = RAW_DATA.val();

          new_followers.push(val.live_follower_delta);
          new_friends.push(val.live_friends_delta);
          new_tweet.push(val.live_tweets_delta);
          total_followers.push(val.total_followers);
          total_friends.push(val.total_friends);
          total_tweets.push(val.total_tweets);
          dates.push(
            moment.tz(val.raw_date, "America/New_York").format('ddd D MMM hA')
          );
        });
      });

      let i_new_followers = List(new_followers.slice(-this.hours));
      let i_new_friends = List(new_friends.slice(-this.hours));
      let i_new_tweets = List(new_tweet.slice(-this.hours));
      let i_total_followers = List(total_followers.slice(-this.hours));
      let i_total_friends = List(total_friends.slice(-this.hours));
      let i_total_tweets = List(total_tweets.slice(-this.hours));
      let i_dates = List(dates.slice(-this.hours));

      dispatch(setNewFollowers(i_new_followers));
      dispatch(setNewFriends(i_new_friends));
      dispatch(setNewTweets(i_new_tweets));
      dispatch(setTotalFollowers(i_total_followers));
      dispatch(setTotalFriends(i_total_friends));
      dispatch(setTotalTweets(i_total_tweets));
      dispatch(setFollowersFriendsTweetsDates(i_dates));
    });
  };


  fetchLikesRetweetsData = async () => {
    let ref2 = db.ref(`engage/girlposts/likes_retweets/archive`)
      .limitToLast(this.days);
    let dispatch = this.props.dispatch;

    await ref2.once('value').then((data) => {

      let new_favorites = [];
      let new_retweets = [];
      let dates = [];

      data.forEach((date_data) => {

        date_data.forEach((hour_data) => {
          let DATA = hour_data.val();
          let unix_milliseconds = DATA.unix_seconds_data_date;

          new_favorites.push(DATA.favorite_delta);
          new_retweets.push(DATA.retweet_delta);
          dates.push(
            moment.tz(unix_milliseconds, "America/New_York")
              .format('ddd D MMM hA')
          );
        });
      });

      let i_new_retweets = List(new_retweets.slice(-this.hours));
      let i_new_favorites = List(new_favorites.slice(-this.hours));
      let i_dates = List(dates.slice(-this.hours));

      dispatch(setNewFavorites(i_new_favorites));
      dispatch(setNewRetweets(i_new_retweets));
      dispatch(setLikesRetweetsDates(i_dates));
    });
  };


  render() {

    let {
      new_favorites,
      new_retweets,
      likes_retweets_dates,
      new_followers,
      new_friends,
      new_tweets,
      total_followers,
      total_friends,
      total_tweets,
      followers_friends_tweets_dates,
      replies_mentions_sums,
      replies_mentions_dates
    }
      = this.props;

    return (
      <div id="dac-d0a">
        <div id="dac-d2a"
             className="dac-d8a"
        >
          <FavoriteChart new_favorites={new_favorites}
                         dates={likes_retweets_dates}
          />
        </div>
        <div id="dac-d3a"
             className="dac-d8a"
        >
          <FollowersChart new_followers={new_followers}
                          total_followers={total_followers}
                          dates={followers_friends_tweets_dates}
          />
        </div>
        <div id="dac-d1a"
             className="dac-d8a"
        >
          <RetweetChart new_retweets={new_retweets}
                        dates={likes_retweets_dates}
          />
        </div>
        <div id="dac-d4a"
             className="dac-d8a"
        >
          <FriendsChart new_friends={new_friends}
                        total_friends={total_friends}
                        dates={followers_friends_tweets_dates}
          />
        </div>
        <div id="dac-d6a"
             className="dac-d8a"
        >
          <RepliesMentionsChart replies_mentions_sums={replies_mentions_sums}
                                replies_mentions_dates={replies_mentions_dates}
          />
        </div>
        <div id="dac-d5a"
             className="dac-d8a"
        >
          <TweetsChart new_tweets={new_tweets}
                       total_tweets={total_tweets}
                       dates={followers_friends_tweets_dates}
          />
        </div>
      </div>
    );
  }
}


EngageDataControl
  = connect(mapStateToProps, mapDispatchToProps)(EngageDataControl);

export default EngageDataControl;


// WEBPACK FOOTER //
// ./src/containers/engage/EngageDataControl.js